<template>
  <section>
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <el-form-item label="组织架构">
        <TenantCustomersSelectVue
          v-model="dataForm.DepartmentId"
          style="width: 220px"
        ></TenantCustomersSelectVue>
      </el-form-item>
      <el-form-item label="客户名称:" prop="CompanyName">
        <el-input
          v-model="dataForm.CompanyName"
          placeholder="请输入客户公司名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="主叫:" prop="Caller">
        <el-input
          type="textarea"
          v-model="dataForm.Caller"
          placeholder="请输入主叫号码"
          clearable
          rows="1"
        ></el-input>
      </el-form-item>
      <el-form-item label="被叫:" prop="Callee">
        <el-input
          type="textarea"
          v-model="dataForm.Callee"
          placeholder="请输入被叫号码"
          clearable
          rows="1"
        ></el-input>
      </el-form-item>
      <el-form-item label="风控等级:" prop="WarningLevel">
        <el-select
          v-model="dataForm.WarningLevel"
          placeholder="请选择风控等级"
          clearable
        >
          <el-option value="Whitelist" label="加白"> </el-option>
          <el-option value="Warning" label="告警"> </el-option>
          <el-option value="Stop" label="停机"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间:">
        <el-date-picker
          :clearable="false"
          v-model="time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeDate"
          :editable="false"
          @keydown.enter.native.stop
          @keydown.native.prevent
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleGetDataList()" type="primary">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="dataList"
      v-loading="dataListLoading"
      ref="table"
      class="custom-tbl"
      style="width: 100%"
    >
      <el-table-column align="center" prop="DepartmentName" label="组织架构">
      </el-table-column>
      <el-table-column align="center" prop="CompanyName" label="客户名称">
      </el-table-column>
      <el-table-column align="center" prop="Caller" label="主叫">
      </el-table-column>
      <el-table-column align="center" prop="Callee" label="被叫">
      </el-table-column>
      <el-table-column align="center" prop="WarningLevel" label="风控等级">
        <template slot-scope="scope">
          <span
            :style="{
              color: scope.row.WarningLevel == 'Whitelist' ? 'green' : 'gray',
            }"
          >
            {{
              scope.row.WarningLevel == "Whitelist"
                ? "白名单"
                : scope.row.WarningLevel == "Warning"
                ? "告警"
                : "停机"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="TotalCount" label="累计违规次数">
      </el-table-column>
      <el-table-column align="center" prop="StopDatetime" label="停机时间">
      </el-table-column>
      <el-table-column align="center" prop="CreationTime" label="创建时间">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChangeHandle1"
      @current-change="pageCurrentChangeHandle1"
      :current-page="page"
      :page-sizes="pageSizes"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float: right; margin-top: 15px"
    >
    </el-pagination>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import moment from "moment";
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
const starttime = moment(new Date()).format("yyyy-MM-DD 00:00:00");
const endtime = moment(new Date()).format("yyyy-MM-DD 23:59:59");
export default {
  mixins: [viewModule],
  components: { TenantCustomersSelectVue },
  data() {
    return {
      time: [starttime, endtime],
      dataForm: {
        Caller: "", //主叫
        Callee: "", //被叫
        StartT: starttime,
        EndT: endtime,
        DepartmentId: "", //组织架构id
        CompanyName: "", //客户公司名称
        WarningLevel: "",
      },
      mixinViewModuleOptions: {
        requestMethod: "post",
        getDataListIsPage: true,
        getDataListURL: "/api/FilterIllegalCallLog/PostAllLegalCallLogList",
        deleteURL: "",
      },
    };
  },
  methods: {
    pageSizeChangeHandle1(val) {
      this.page = 1;
      this.limit = val;
      this.handleGetDataList();
    },
    pageCurrentChangeHandle1(val) {
      this.page = val;
      this.handleGetDataList();
    },
    handleGetDataList() {
      this.page = 1
      const oldcallee = JSON.parse(JSON.stringify(this.dataForm.Callee));
      const oldcaller = JSON.parse(JSON.stringify(this.dataForm.Caller));
      if (typeof this.dataForm.Callee === "string") {
        this.dataForm.Callee = this.dataForm.Callee.split("\n").filter(
          (v) => !!v
        );
      }
      if (typeof this.dataForm.Caller === "string") {
        this.dataForm.Caller = this.dataForm.Caller.split("\n").filter(
          (v) => !!v
        );
      }
      this.query();
      this.dataForm.Callee = oldcallee;
      this.dataForm.Caller = oldcaller;
    },
    ExcelAdd() {
      this.$refs.importStopNumber.init();
    },
    downloadExcelFile(path) {
      window.open(path);
    },
    changeDate(e) {
      if (e) {
        // 调整时区偏移
        const start = new Date(e[0]);
        const end = new Date(e[1]);
        const offset = start.getTimezoneOffset() * 60000; // 毫秒
        this.dataForm.StartT = new Date(start.getTime() - offset).toISOString();
        this.dataForm.EndT = new Date(end.getTime() - offset).toISOString();
      } else {
        this.dataForm.StartT = "";
        this.dataForm.EndT = "";
      }
    },
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>